import { initializeApp } from 'firebase/app';
import { getFirestore } from 'firebase/firestore';
import { getAuth } from 'firebase/auth';

// Your Firebase configuration
const firebaseConfig = {
  // TODO: Replace with your Firebase config
  apiKey: "AIzaSyA7clmMfBTIFXQ8j_rA8-dXLuABpv2jj0o",
  authDomain: "akademi-29305.firebaseapp.com",
  projectId: "akademi-29305",
  storageBucket: "akademi-29305.firebasestorage.app",
  messagingSenderId: "757242019387",
  appId: "1:757242019387:web:370738106c763bc342661e"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
export const db = getFirestore(app);
export const auth = getAuth(app); 